import { Typography } from '../../../components/typography/typography';
import { useOutletContext } from 'react-router-dom';
import { AdminViewContext } from './admin-user-view';
import { useAdmin } from '../../../hooks/use-admin-context';
import { PasswordChangeForm } from '../components/password-change-form';

export const AdminUserPassword = () => {
  const { admin } = useOutletContext<AdminViewContext>();
  const { id: adminLoggedId } = useAdmin();

  return (
    <div className="tab-section">
      <div className="tab-title">
        <Typography type="text-xl" weight="semi-bold">
          Change Password
        </Typography>
      </div>

      <div className="card">
        <PasswordChangeForm admin={admin} showCurrentPassword={admin?.adminId === adminLoggedId} />
      </div>
    </div>
  );
};
